import { Component, Input, OnInit } from '@angular/core';
import { CONFIG } from '../../../config';
import { CompanyTooltipDataInt } from '../../models/company-tooltip-data.interface';
import { positionTypeBadgeLabel } from '../../enums/position-type.enum';
import { StockType } from '../../enums/stock-type.enum';

@Component({
    selector: 'rms-sym',
    templateUrl: './sym.component.html',
    styleUrls: ['./sym.component.scss'],
    standalone: false
})
export class SymComponent implements OnInit {

  @Input() item: CompanyTooltipDataInt;
  @Input() customClass: string;
  @Input() displayPositionTypeBadge: boolean;
  @Input() displayStrikePrice: boolean;

  public tooltipOpenDelay = CONFIG.tooltipOpenDelay;

  public positionTypeBadge: string;

  constructor() { }

  ngOnInit(): void {
    if (this.displayPositionTypeBadge) {
      this.positionTypeBadge = positionTypeBadgeLabel(this.item.positionType);
    }
  }

  public getTitle(): string {
    return this.item.company.ticker && this.item.stockType !== StockType.BASKET_SWAP ? this.item.company.ticker : this.item.company.name;
  }

}
